// YouTube
(function (document, scriptTag, scriptUrl, scriptElement, firstScriptElement) {
    scriptElement = document.createElement(scriptTag);
    scriptElement.async = 1;
    scriptElement.src = scriptUrl;
    firstScriptElement = document.getElementsByTagName(scriptTag)[0];
    firstScriptElement.parentNode.insertBefore(
        scriptElement,
        firstScriptElement
    );
})(document, 'script', 'https://www.youtube.com/iframe_api');
// End YouTube
